module.exports = __webpack_public_path__ + "img/contact.7684cb3c.png";